var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.selectContainer},[_c('select',_vm._g({class:_vm.$style.select,domProps:{"value":_vm.value}},_vm.listeners),[_vm._t("default")],2),_c('div',{class:_vm.$style.arrow},[_c('BaseIcon',{class:[_vm.$style.icon, _vm.$style.iconMore],attrs:{"name":"expand_more"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }